import { render } from "./CustomerMarketingPreferencesModal.vue?vue&type=template&id=781922cc"
import script from "./CustomerMarketingPreferencesModal.vue?vue&type=script&lang=js"
export * from "./CustomerMarketingPreferencesModal.vue?vue&type=script&lang=js"

import "./CustomerMarketingPreferencesModal.vue?vue&type=style&index=0&id=781922cc&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__